
// List of article images
const imageUrls = [
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS4Fl6-95Vpd1uCumsq5zRzziS5i717TxE0DQ&s",
  "https://www.sarit-lari.co.il/wp-content/uploads/2024/04/A-mortgage-for-any-purpose.png",
  "https://www.taxfinance.co.il/wp-content/uploads/2021/11/%D7%94%D7%97%D7%96%D7%A8-%D7%9E%D7%A1-%D7%9E%D7%A9%D7%9B%D7%A0%D7%AA%D7%90.jpg",
  "https://www.hon.co.il/wp-content/uploads/2011/11/%D7%9E%D7%93%D7%A8%D7%99%D7%9B%D7%99-%D7%9E%D7%A9%D7%9B%D7%A0%D7%AA%D7%90%D7%95%D7%AA-55x55-1.jpg",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRg8XUmVrHyyJYi_nX7XhmqVvxuRCZsxYXddg&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8mstqgQrshWiJkwhS91-GFjZIa8bBmANtZw&s"
];

const getRandomImage = () => {
  return imageUrls[Math.floor(Math.random() * imageUrls.length)];
};
const articles = [
  { 
      id: 1, 
      title: "משכנתא מול הלוואה בנקאית", 
      description: "כאשר אתם עומדים בפני החלטה כלכלית משמעותית כמו רכישת דירה או נכס, אתם עשויים להיתקל בשני מונחים חשובים: משכנתא והלוואה בנקאית. מהו ההבדל בין השניים, ומתי כדאי להשתמש בכל אחד מהם? במאמר זה נבחן את המאפיינים הייחודיים של כל סוג הלוואה, הבטוחות הנדרשות, תקופות ההחזר, תנאי הריבית, ועוד כדי לעזור לכם לקבל את ההחלטה המיטבית לצרכים שלכם.",
      image: "/images/articles/1.jpg",
      date: "2024-01-05" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 2, 
      title: "סוגי ריביות, יתרונות וחסרונות", 
      description: "במאמר זה נעמיק ביתרונות והחסרונות של כל סוג ריבית – מקבועה צמודה ולא צמודה למדד, דרך ריביות משתנות וריבית פריים, ועד מסלולי ריבית במטבע חוץ. הכרות מעמיקה עם כל אחד מהם תסייע לכם לבחור את המסלול המתאים ביותר לצרכים האישיים ולתנאים הפיננסיים שלכם, בדרך לקבלת החלטה מושכלת שתלווה אתכם לאורך זמן.",
      image: "/images/articles/2.jpg",
      date: "2024-01-08" ,
      relatedArticles: [2, 5, 6]
  },
  { 
      id: 3, 
      title: "עמלת פירעון מוקדם", 
      description: "מתכננים לסגור את המשכנתא מוקדם? לפני שאתם מתחילים, כדאי להכיר את קנס הפירעון המוקדם – תוספת תשלום שנועדה לפצות את הבנק על הפסד הריבית העתידית.",
      image: "/images/articles/3.png",
      date: "2024-01-11" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 4, 
      title: "רכישת דירה ראשונה", 
      description: "רכישת דירה ראשונה היא צעד מרגש, אך כרוך באתגרים כלכליים ותפעוליים. מהבנת העלויות האמיתיות, דרך בדיקת הון עצמי ויכולת החזר, ועד ניהול תהליך המשכנתא בצורה מסודרת",
      image: "/images/articles/4.jpeg",
      date: "2024-01-15" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 5, 
      title: "רגולציה", 
      description: "רגולציה בתחום המשכנתאות נועדה להגן על הצרכן, להבטיח שקיפות, ולשמור על יציבות שוק הנדלן. במאמר נסקור את מטרות הרגולציה, ההגבלות על המשכנתא והפיקוח על הבנקים, לצד יתרונות כגון שקיפות והגנה מפני ניצול.",
      image: "/images/articles/5.jpeg",
      date: "2024-01-17" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 6, 
      title: "אישור עקרוני", 
      description: "אישור עקרוני למשכנתא הוא מסמך ראשוני שמנפיק הבנק, המאשר את האפשרות לקבל הלוואת משכנתא בהתאם לנתונים האישיים שלכם ולמאפייני הנכס המבוקש. האישור מספק מסגרת ראשונית לסכום ההלוואה ותנאיה, ותוקפו למשך 24 ימים עבור הריביות",
      image: "/images/articles/6.jpeg",
      date: "2024-01-18" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 7, 
      title: "כיצד לשפר את דירוג האשראי שלך", 
      description: "דירוג האשראי משפיע על יכולתך לקבל תנאים טובים במשכנתא. במאמר זה נלמד כיצד לשפר את הדירוג שלך, אילו טעויות להימנע מהן, ואילו פעולות יעזרו לך להיראות כלווה אמין בעיני הבנקים.",
      image: getRandomImage(),
      date: "2024-01-22" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 8, 
      title: "משכנתאות בריבית קבועה מול משתנה", 
      description: "השוואה מעמיקה בין ריבית קבועה לריבית משתנה במשכנתאות. במאמר זה נבחן את היתרונות והחסרונות של כל מסלול, מהו המסלול שמתאים יותר לסוגי לווים שונים ואיך לבחור בין מסלולים בהתאם לתנאי השוק.",
      image: getRandomImage(),
      date: "2024-02-10" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 9, 
      title: "אישור מוקדם למשכנתא - יתרונות וחסרונות", 
      description: "אישור מוקדם הוא כלי חשוב עבור לווים רציניים בתהליך רכישת נכס. המאמר מסביר מהם היתרונות באישור מוקדם, כיצד הוא משפיע על אמינות הקונה בעיני המוכרים, ואילו חסרונות יש לשיטה זו.",
      image: getRandomImage(),
      date: "2024-02-26" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 10, 
      title: "כמה תוכל ללוות? הבנת מגבלות הלוואה", 
      description: "מהם הגורמים שקובעים את סכום המשכנתא שתוכלו לקבל? המאמר מספק כלים להבנת מגבלות ההלוואה, מסביר כיצד לחשב את יכולת ההחזר וכיצד להתאים את סכום ההלוואה ליכולות הכלכליות שלכם.",
      image: getRandomImage(),
      date: "2024-03-06" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 11, 
      title: "חיסכון להון עצמי לרכישת דירה", 
      description: "כיצד לחסוך להון עצמי הדרוש לרכישת נכס, כולל שיטות ניהול תקציב וניהול פיננסי חכם. המאמר מציג תובנות מעשיות וכלים לעמידה ביעדים הפיננסיים שלכם במהירות וביעילות.",
      image: getRandomImage(),
      date: "2024-03-10" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 12, 
      title: "משכנתאות לעומת הלוואות הון עצמי", 
      description: "מהם ההבדלים המרכזיים בין משכנתאות להלוואות הון עצמי, ואילו שימושים מתאימים לכל סוג של הלוואה. המאמר מסביר גם כיצד להיעזר בהון עצמי למימון השקעות נוספות.",
      image: getRandomImage(),
      date: "2024-03-28" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 13, 
      title: "הבנת עלויות סגירה בעת רכישת דירה", 
      description: "במהלך רכישת דירה, קיימות עלויות סגירה נוספות שיש לקחת בחשבון. מאמר זה מספק רשימה מקיפה של עלויות אלו, כולל שיטות להתארגנות כלכלית טובה יותר לקראתן.",
      image: getRandomImage(),
      date: "2024-04-18" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 14, 
      title: "מדד תשומות הבנייה", 
      description: "במאמר זה נסקור את מדד תשומות הבנייה, השפעתו על רכישת דירה מקבלן, וכיצד להתמודד עם העלויות הנוספות באמצעות תכנון נכון, שיח עם הקבלן וייעוץ מקצועי.",
      image: getRandomImage(),
      date: "2024-04-29" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 15, 
      title: "חשיבות ביטוח משכנתא והגנת הנכס", 
      description: "ביטוח משכנתא הוא מרכיב חשוב להגן על הנכס ועל ההשקעה שלכם. המאמר מסביר את סוגי הביטוחים הקיימים, ומדוע ביטוח משכנתא הוא חובה בתהליך רכישת דירה.",
      image: getRandomImage(),
      date: "2024-05-05" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 16, 
      title: "רכישת דירה עם הכנסה נמוכה", 
      description: "כיצד ניתן לרכוש דירה גם בהכנסה נמוכה? מאמר זה מציג אפשרויות כלכליות למי שמעוניין לרכוש נכס אך נתקל באתגרים כלכליים, כולל תמיכות ממשלתיות ותוכניות מסובסדות.",
      image: getRandomImage(),
      date: "2024-05-22" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 17, 
      title: "הבנת תהליכי עיקול ואיך להימנע מהם", 
      description: "מהו תהליך העיקול ואיך ניתן להימנע ממנו? מאמר זה בוחן את הסיכונים, ומציג עצות לניהול כלכלי נכון שיסייעו לשמור על הנכס במקרה של קושי כלכלי.",
      image: getRandomImage(),
      date: "2024-06-02" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 18, 
      title: "משכנתא ל-15 שנה מול 30 שנה: יתרונות וחסרונות", 
      description: "השוואה בין תקופות משכנתא שונות וכיצד זה משפיע על ההחזרים החודשיים שלכם. המאמר מסביר גם את ההשלכות הכלכליות של תקופות החזר שונות ומתי כדאי לבחור בכל אחת מהן.",
      image: getRandomImage(),
      date: "2024-07-01" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 19, 
      title: "שלבי תהליך הגשת בקשה למשכנתא", 
      description: "מדריך מעשי לכל השלבים בתהליך הגשת בקשת המשכנתא, כולל הכנת המסמכים, הצגת התנאים, וקבלת האישור הסופי מהבנק.",
      image: getRandomImage(),
      date: "2024-07-19" ,
      relatedArticles: [1, 2, 3]
  },
  { 
      id: 20, 
      title: "מה תפקידו של יועץ משכנתא?", 
      description: "יועץ משכנתא עוזר בליווי לקוחות ומשא ומתן עם המלווים כדי למצוא את התנאים הטובים ביותר למשכנתא. במאמר זה נסביר את תפקיד היועץ, יתרונות השירות וכיצד הוא מקצר את תהליך המשכנתא.",
      image: getRandomImage(),
      date: "2024-07-24" ,
      relatedArticles: [1, 2, 3]
  }
];

export default articles;
